import React, { useState, useEffect, useRef } from "react";
import { useUserContext } from "store/contexts/userContext";
import { ReactComponent as VideoOnn } from "assets/img/icons/video-on.svg";
import { ReactComponent as MicOnnIcon } from "assets/img/icons/mic.svg";
import { ReactComponent as MicOffIcon } from "assets/img/icons/microphone.svg";
import { ReactComponent as VideoOff } from "assets/img/icons/video-call.svg";
import { useWaterCoolerContext } from "store/contexts/waterCoolerContext";

const styles = {
  textHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "2",
    color: "white",
    fontSize: "20px",
    lineHeight: "30px",
    fontWeight: 400,
    fontFamily: "sans-serif",
    textTransform: "uppercase",
  },
  icons: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    position: "absolute",
    width: "100%",
    height: "96%",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    zIndex: "2",
    color: "white",
  },
  displayIcons: {
    width: "inherit",
    maxWidth: "302px",
    display: "flex",
    justifyContent: "space-around",
    backgroundColor: "#4343434a",
    padding: "10px 0",
  },
  notSupport: {
    maxWidth: "300px",
    fontSize: "initial !important",
  },
};

export default ({ participant, members, enableVideo, notSupported }) => {
  const [videoTracks, setVideoTracks] = useState([]);
  const { room } = useWaterCoolerContext();
  const [audioTracks, setAudioTracks] = useState([]);
  const { user } = useUserContext();
  const [localParticipant] = useState(
    user.id === parseInt(participant.identity)
  );
  const [disableAudio, setDisableAudio] = useState(true);
  const [disableVideo, setDisableVideo] = useState(true);
  const classes = styles;
  const [userVideoOff, setUserVideoOff] = useState("You");
  const videoRef = useRef();
  const audioRef = useRef();

  useEffect(() => {
    if (room) {

    }

    participant.tracks.forEach((publication) => {
      if (publication.kind === "audio") {
        setDisableAudio(!publication.isTrackEnabled);
      }
      if (publication.kind === "video") {
        setDisableVideo(!publication.isTrackEnabled);
      }
    });

    //eslint-disable-next-line
  }, [participant]);

  useEffect(() => {
    if (members === undefined) {
      return;
    }
    var memberName = members?.filter(
      (member) => member?.attributes?.email === participant?.identity
    );
    if (memberName !== undefined) {
      var str = memberName[0]?.attributes?.full_name;
    }
    var matches = str?.match(/\b(\w)/g);
    if (matches?.length > 3) {
      matches.pop();
    }
    var result = matches?.join("");
    setUserVideoOff(result);
    //eslint-disable-next-line
  }, [members]);

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    const trackSubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => [...videoTracks, track]);
      } else {
        setAudioTracks((audioTracks) => [...audioTracks, track]);
      }
    };

    const trackUnsubscribed = (track) => {
      if (track.kind === "video") {
        setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
      } else {
        setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
      }
    };

    const handleTrackDisabled = (track) => {
      track.on("disabled", (track) => {
        if (track.kind === "video") {
          setDisableVideo(true);
          return;
        }
        setDisableAudio(true);
      });
    };

    const handleTrackEnabled = (track) => {
      track.on("enabled", () => {
        if (track.kind === "video") {
          setDisableVideo(false);
          return;
        }
        setDisableAudio(false);
      });
    };

    setVideoTracks(trackpubsToTracks(participant.videoTracks));
    setAudioTracks(trackpubsToTracks(participant.audioTracks));

    participant.on("trackSubscribed", trackSubscribed);
    participant.on("trackUnsubscribed", trackUnsubscribed);
    participant.tracks.forEach((publication) => {
      if (publication.isSubscribed) {
        handleTrackDisabled(publication.track);
        handleTrackEnabled(publication.track);
      }
      publication.on("subscribed", handleTrackDisabled);
      publication.on("subscribed", handleTrackEnabled);
    });

    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      // setDisableVideo(false);
      // setDisableAudio(false);
      // participant.removeAllListeners();
    };
  }, [participant]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);

  return (
    <div className="waterCoolerVideoRoot">
      <video
        className="waterCoolerVideo"
        width="300"
        height="300"
        ref={videoRef}
        preload="metadata"
        autoPlay={true}
        playsInline
      />
      <audio ref={audioRef} autoPlay={true} />
      {disableVideo && !localParticipant && (
        <div className="waterCoolerOverlay" />
      )}
      {notSupported && localParticipant && (
        <div style={classes.textHeading}>
          <span style={classes.notSupport}>{notSupported?.description}</span>
        </div>
      )}
      {disableVideo && !localParticipant && (
        <div style={classes.textHeading}>
          <span>{userVideoOff}</span>
        </div>
      )}
      {!enableVideo && localParticipant && !notSupported && (
        <div style={classes.textHeading}>
          <span>You</span>
        </div>
      )}
      {!localParticipant && (
        <div style={classes.icons}>
          <div className="waterCoolerDisplayIcons">
            {!disableVideo && (
              <VideoOnn className="mw-22" style={{ fill: "white" }} />
            )}
            {disableVideo && (
              <VideoOff className="mw-22" style={{ fill: "white" }} />
            )}
            {!disableAudio && (
              <MicOnnIcon className="mw-22" style={{ fill: "white" }} />
            )}
            {disableAudio && (
              <MicOffIcon className="mw-22" style={{ fill: "white" }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
